module.exports = __webpack_public_path__ + "static/phone-84ad48133369a6a3525192b15348fa21.jpg";